export default __webpack_public_path__ + "static/media/GOAL-BUSD.8c044013.png";